// Firebase client config

interface FirebaseClientConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
}

export async function getFirebaseClientConfig(): Promise<FirebaseClientConfig> {
  // ! DO NOT CHECK FOR THE ENVIRONMENT VARIABLES DYNAMICALLY (ex: with a loop)
  // ! FOR THEM TO BE REPLACED BY THEIR VALUE AT BUILD TIME BY NEXTJS

  // Check if environment variables are available
  if (!process.env.NEXT_PUBLIC_FIREBASE_API_KEY) {
    throw new Error('FIREBASE_API_KEY is not set');
  }
  if (!process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN) {
    throw new Error('FIREBASE_AUTH_DOMAIN is not set');
  }
  if (!process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID) {
    throw new Error('FIREBASE_PROJECT_ID is not set');
  }
  if (!process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET) {
    throw new Error('FIREBASE_STORAGE_BUCKET is not set');
  }
  if (!process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID) {
    throw new Error('FIREBASE_MESSAGING_SENDER_ID is not set');
  }
  if (!process.env.NEXT_PUBLIC_FIREBASE_APP_ID) {
    throw new Error('FIREBASE_APP_ID is not set');
  }
  if (!process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID) {
    console.warn('FIREBASE_MEASUREMENT_ID is not set');
  }

  return {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
  };
}
